import React, { ReactNode } from 'react'
import { cn } from '../../../components/shadcn/utils'

export function SquareAmountCell({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="place-self-center self-center flex justify-center flex-1">
      <div className={cn('min-w-9 h-9 rounded-xl bg-slate-600 inline-flex items-center justify-center', className)}>
        <span className="square-amount mx-1 text-center">{children}</span>
      </div>
    </div>
  )
}
